import React from 'react';
import { useSelector } from 'react-redux';
import { UserSettings, ClientInfo, OrchestrationServiceInfo, WhiteLabelConfig, SessionInfo, LoggerHandler, LogInfo, MeasurementHandler, MeasurementMessage } from '@cart-js/core';
import { selectIsWebViewFromBootstrap, selectWhitelabelConfigFromBootstrap } from 'store/slice/bootstrap';
import { selectClientInfo, selectServiceForCart, selectSessionInfo, selectUserSetting } from 'core/context/WrappedCartConfig/WrappedCartConfig.selectors';
import * as Logger from 'core/messaging/logger/logger';
import * as Measurement from 'core/messaging/measurement/measurement';
import { getBootstrapConfig } from 'core/window/windowService';

export interface CartSetupConfigs {
    setClientInfo: (clientInfo: ClientInfo) => void;
    setUserSettings: (userSettings: UserSettings) => void;
    setServices: (services: OrchestrationServiceInfo) => void;
    setWhiteLabelConfig: (wlConfig: WhiteLabelConfig) => void;
    setSessionInfo: (sessionInfo: SessionInfo) => void;
    setLogger: (logger: LoggerHandler) => void;
    setIsWebView: (isWebView: boolean) => void;
    setMeasurement: (measurement: MeasurementHandler) => void;
}

/* eslint-disable react-hooks/exhaustive-deps */
export const useCartConfig = ({ setServices, setClientInfo, setUserSettings, setWhiteLabelConfig, setSessionInfo, setLogger, setIsWebView, setMeasurement }: CartSetupConfigs) => {
    const wlConfig = useSelector(selectWhitelabelConfigFromBootstrap);
    const services = useSelector(selectServiceForCart);
    const userSettings = useSelector(selectUserSetting);
    const clientInfo = useSelector(selectClientInfo);
    const sessionInfo = useSelector(selectSessionInfo);
    const isWebView = useSelector(selectIsWebViewFromBootstrap);

    React.useEffect(() => {
        setClientInfo(clientInfo);
    }, [clientInfo]);

    React.useEffect(() => {
        setUserSettings(userSettings);
    }, [userSettings]);

    React.useEffect(() => {
        setServices(services);
    }, [services]);

    React.useEffect(() => {
        setWhiteLabelConfig(wlConfig);
    }, [wlConfig]);

    React.useEffect(() => {
        setIsWebView?.(isWebView);
    }, []);

    React.useEffect(() => {
        setSessionInfo(sessionInfo);
    }, [sessionInfo]);

    React.useEffect(() => {
        const logAdapter = ({ logLevel, message, tags }: LogInfo) => {
            Logger.log(logLevel, message, undefined, tags);
        };
        setLogger(logAdapter);
    }, [setLogger]);

    React.useEffect(() => {
        const measurementAdapter = ({ name, measurement, count, tags }: MeasurementMessage) => {
            const config = getBootstrapConfig();
            Measurement.send(name, measurement, count, config.pageConfig.pageTypeId, tags, true);
        };
        setMeasurement(measurementAdapter);
    }, [setMeasurement]);

    return null;
};
